var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"compare-widget"}},[_c('v-app',[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[(_vm.showComparison)?_c('LoanService',{attrs:{"widgetParams":_vm.widgetParams,"queryParams":_vm.queryParams}}):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }